module.exports = __webpack_public_path__ + "img/logo.f315f8b9.jpg";